'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.15.3.1@react/react.js
 ** module id = 169
 ** module chunks = 0
 **/